import { Injectable } from '@angular/core'
import { AuthenticationService } from '../authentication/services/authentication.service'
import * as md5 from 'tiny-js-md5'
import { EnvironmentService } from '../environment/environment.service'

export type DataLayerEventObject = {
    event: string
    userId?: string
    [key: string]: string
}

@Injectable({
    providedIn: 'root',
})
export class DataLayerService {
    constructor(private authenticationService: AuthenticationService, private environmentService: EnvironmentService) {
        // @ts-ignore
        window.dataLayer = window.dataLayer || []
    }

    push(eventObject: DataLayerEventObject) {
        // userId must be undefined when user has not logged in anymore (gdpr)
        // otherwise, attach user id to session
        const user = this.authenticationService.currentUser.getValue()
        eventObject.userId = user ? md5(user.email.toLowerCase().trim()) : undefined

        if (!this.environmentService.environment.production) {
            console.log(eventObject)
        }

        // @ts-ignore
        window.dataLayer.push(eventObject)
    }
}
